import React from 'react';

export default function NeedhamBrand() {
  return (
    <div className="needham-brand">
      <a
  href="https://needhamtechstudio.com"
  target="_blank"
  rel="author noopener noreferrer"
  className="needham-link"
>
  <img src="/NeedhamTechNavLogo.png" alt="Needham Tech Studio" className="needham-logo" />
  <span>Designed &amp; Developed by Needham Tech Studio</span>
</a>
    </div>
  );
}